import React from 'react';
import { connect } from 'react-redux';

import UpgradeToProfessionalModal from './UpgradeToProfessionalModal';

import * as userSelectors from '../../redux/auth/user/selectors';
import * as upgradeSubscriptionSelectors from '../../redux/auth/upgradeSubscription/selectors';
import * as uiSelectors from '../../redux/ui/selectors';

import { updateSubscription } from '../../redux/auth/upgradeSubscription/actions';
import { hideUpdateSubscriptionModal } from '../../redux/ui/actions';

const UpgradeToProfessionalModalConnected = (props) => <UpgradeToProfessionalModal {...props} />;

const mapStateToProps = (state) => ({
  isLoading: upgradeSubscriptionSelectors.selectIsLoading(state),
  error: upgradeSubscriptionSelectors.selectError(state),
  errorMessage: upgradeSubscriptionSelectors.selectErrorMessage(state),

  isVisible: uiSelectors.selectIsUpdateSubscriptionModalVisible(state),

  isUserAdvanced: userSelectors.selectIsUserAdvanced(state),
});

const mapActionsToProps = {
  updateSubscription,
  hideUpdateSubscriptionModal,
};

export default connect(mapStateToProps, mapActionsToProps)(UpgradeToProfessionalModalConnected);
